module.exports = __webpack_public_path__ + "img/logo.fb1860e9.png";